import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => {
  return {
    root: {
      color: theme.palette.error.light,

      '&:first-letter': {
        textTransform: 'capitalize',
      },
    },

    sidePadding: {
      padding: theme.spacing(1),
    },
  };
});
